let _SpyHandlers = null;
export const spyHandlers = (fn) => {
    const prevHandlers = _SpyHandlers;
    _SpyHandlers = [];
    fn();
    const result = _SpyHandlers;
    _SpyHandlers = prevHandlers;
    return result;
};
export class EventNode {
    constructor(global) {
        this._global = global;
        this._events = {};
        this._handlers = [];
    }
    $on(name, callback, target) {
        const h = { name, callback, target, bus: this };
        this._handlers.push(h);
        if (_SpyHandlers) {
            _SpyHandlers.push(h);
        }
        return h;
    }
    $off(ctl) {
        this._handlers = this._handlers.filter(l => l != ctl && l.callback != ctl && l.target != ctl);
    }
    $emit(name, ...args) {
        //        console.log('emit', name, args, this._handlers)
        // TODO возможно, сообщения стоит здесь только помещать в очередь
        this._handlers.forEach(h => {
            if (h.name == name) {
                //                console.log('call handler')
                h.callback.apply(h.target, args);
            }
        });
    }
    $event(name) {
        this._events[name] = true;
        return (...args) => this.$emit.apply(this, [name, ...args]);
    }
    $hasEvent(name) {
        return !!this._events[name] || (this._global != null && this._global[name]);
    }
}
